import React from "react";
import { cn } from "./utils";

export const Card = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn("tw-min-w-0 tw-rounded-lg tw-border tw-bg-card tw-text-card-foreground tw-shadow-sm", className)}
    {...props}
  />
));
Card.displayName = "Card";

export const CardHeader = ({ className, ...props }) => (
  <div className={cn("tw-flex tw-flex-wrap tw-items-start tw-justify-between tw-gap-3 tw-p-4 tw-pb-3", className)} {...props} />
);

export const CardTitle = ({ className, as: Tag = "h3", ...props }) => (
  <Tag className={cn("tw-m-0 tw-font-sans tw-text-sm tw-font-semibold tw-leading-5 tw-text-foreground", className)} {...props} />
);

export const CardDescription = ({ className, ...props }) => (
  <div className={cn("tw-m-0 tw-mt-0.5 tw-text-xs tw-leading-4 tw-text-muted-foreground", className)} {...props} />
);

export const CardContent = ({ className, ...props }) => <div className={cn("tw-p-4 tw-pt-0", className)} {...props} />;

export const CardFooter = ({ className, ...props }) => (
  <div className={cn("tw-flex tw-items-center tw-gap-2 tw-p-4 tw-pt-0", className)} {...props} />
);
